import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.matches.interestedInMe;

const getPeopleExpressedInterestInMe = createSelector(
  getData,
  interestedInMe => interestedInMe
);

export default getPeopleExpressedInterestInMe;



// WEBPACK FOOTER //
// ./src/_selectors/matchesSelectors/getPeopleExpresesedInterestInMe.js